import { ConstantType } from '../../../helpers/types/_common';
import { CalendarType } from './types';

export const CALENDAR_TYPE: ConstantType<CalendarType> = {
  grid: 'grid',
  row: 'row',
  new: 'new',
};
